
export class BaseOperationModel {
  identities: string[];
  searchExistingUsers: boolean;
  startDelay: string;
}
